import { render } from "./SnackbarComponent.vue?vue&type=template&id=5e4b1e92&ts=true"
import script from "./SnackbarComponent.vue?vue&type=script&lang=ts"
export * from "./SnackbarComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3138346141/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__